import DataObjectList from '../../../common/model/DataObjectList';

import Counterparty from './Counterparty';

export default class CounterpartyList extends DataObjectList {
  getElementClassType() {
    return Counterparty;
  }
}